import { useSetRecoilState } from 'recoil';
import { BillingInfoState, IBillingInfoState } from '.';
import API from '../../api';
import { PromoCodeLoading } from '../promo-code';

export type BillingInfoHook = {
  getInfo: (businessId: string) => Promise<IBillingInfoState>;
  resetBillingInfoState: () => void;
};

export const useBillingInfo = (): BillingInfoHook => {
  const setBillingInfoState = useSetRecoilState(BillingInfoState);
  const setPromoCodeLoading = useSetRecoilState(PromoCodeLoading);

  const getInfo = async (businessId: string): Promise<IBillingInfoState> => {
    const billingInfo = await API.billingInfo.find({ businessId });
    setBillingInfoState(billingInfo);
    setPromoCodeLoading(false);
    return billingInfo;
  };

  const resetBillingInfoState = () => {
    setBillingInfoState(null);
  };

  return { getInfo, resetBillingInfoState };
};
